import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import "../styles/Articles.css";
import articulo1 from "../img/articles/upcycling-title.png";
import articulo2 from "../img/articles/lavynieta-title.png";
import articulo3 from "../img/articles/cuina-title.png";
import articulo4 from "../img/articles/carlota-title.png";
import articulo5 from "../img/articles/calonge-title.png";
import articulo6 from "../img/articles/clos-title.png";

const translations = {
  ES: {
    title: "Artículos Destacados",
    articles: [
      {
        id: "upcycling-bottles",
        image: articulo1,
        title: "Upcycling Bottles",
        text: "Diseño y artesanía para reducir nuestro residuos",
      },
      {
        id: "celler-la-vinyeta",
        image: articulo2,
        title: "Celler La Vinyeta",
        text: "Recuperación de levaduras",
      },
      {
        id: "cuina-empordanet",
        image: articulo3,
        title: "La Cuina de l’Empordanet",
        text: "Colectivo gastronómico",
      },
      {
        id: "carlota-pena",
        image: articulo4,
        title: "Carlota Pena",
        text: "viticultura biodinámica",
      },
      {
        id: "calonge",
        image: articulo5,
        title: "Calonge i Sant Antoni",
        text: "Una historia única",
      },
      {
        id: "clos-dagon",
        image: articulo6,
        title: "Miguel Coronado",
        text: "El oficio del enólogo",
      },
    ],
  },
  CAT: {
    title: "Articles Destacats",
    articles: [
      {
        id: "upcycling-bottles",
        image: articulo1,
        title: "Upcycling Bottles",
        text: "Disseny i artesania per reduir els nostres residus",
      },
      {
        id: "celler-la-vinyeta",
        image: articulo2,
        title: "Celler La Vinyeta",
        text: "Recuperació de llevats",
      },
      {
        id: "cuina-empordanet",
        image: articulo3,
        title: "La Cuina de l’Empordanet",
        text: "Col·lectiu gastronòmic",
      },
      {
        id: "carlota-pena",
        image: articulo4,
        title: "Carlota Pena",
        text: "Viticultura biodinàmica",
      },
      {
        id: "calonge",
        image: articulo5,
        title: "Calonge i Sant Antoni:",
        text: "Una història única",
      },
      {
        id: "clos-dagon",
        image: articulo6,
        title: "Miguel Coronado",
        text: "L'ofici de l'enòleg",
      },
    ],
  },
};

const Articles = () => {
  const { language } = useLanguage();
  const { title, articles } = translations[language];

  return (
    <section id="articulos" className="articles">
      <h2>{title}</h2>
      <div className="articles-container">
        {articles.map((article, index) => (
          <Link
            key={index}
            to={`/articulo/${article.id}`}
            className="article-card"
          >
            <img
              src={article.image}
              alt={article.title}
              className="article-card-image"
            />
            <h3>{article.title}</h3>
            <p>{article.text}</p>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default Articles;
